import { useGetAllEnabledExamCoursesQuery } from '@exam-center/graphql';
import { DataGridWithCheckbox, NoRowsOverlay } from '@shared/components';
import { useMemo } from 'react';
import { useController } from 'react-hook-form';

import { columns } from './columns';

interface ExaminationCourseFormListProps {
  name: string;
}

export default function ExaminationCourseFormList(props: Readonly<ExaminationCourseFormListProps>) {
  const { name } = props;

  const { field } = useController({
    name,
  });

  const { data, loading: isLoading } = useGetAllEnabledExamCoursesQuery();

  const examCourses = useMemo(() => {
    return [...(data?.ecGetAllEnabledExamCourses?.examCourses ?? [])].sort(
      (a, b) => a.examId - b.examId,
    );
  }, [data?.ecGetAllEnabledExamCourses]);

  return (
    <DataGridWithCheckbox
      disableColumnMenu
      onRowSelectionModelChange={(value) => {
        field.onChange(value);
      }}
      slots={{
        noRowsOverlay: NoRowsOverlay,
      }}
      loading={isLoading}
      columns={columns}
      rows={examCourses}
      getRowHeight={() => 'auto'}
      getRowId={(row) => row.code}
      hideFooter
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '& .MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '& .MuiDataGrid-columnHeader': {
          px: theme.spacing(3),
        },
        '& .MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
        '& .MuiCheckbox-root': {
          padding: 0,
        },
        '& .MuiDataGrid-cellCheckbox': {
          maxWidth: 'min-content',
          maxHeight: 'min-content',
          color: theme.palette.grey[400],
        },
      })}
    />
  );
}
